/**
 * Cliente helper para invocar la Cloud Function `sendNotification`.
 *
 * Uso principal:
 * - dashboard admin construye el payload,
 * - esta utilidad llama a Functions,
 * - Firebase Admin SDK entrega el push a los tokens FCM seleccionados.
 */
import { getFunctions, httpsCallable } from "firebase/functions";

const functions = getFunctions();
const sendNotificationCallable = httpsCallable(functions, "sendNotification");

export const sendPushNotification = async (payload, tokens) => {
  const dataToSend = { payload, tokens };

  try {
    const response = await sendNotificationCallable(dataToSend);
    return response.data;
  } catch (error) {
    console.error("Error al enviar notificaciones:", error);
    throw error;
  }
};
